export const TASK = 'Tasks';
export const APPRAISAL = 'Mark For Appraisal';
export const PROJECT = 'Project';
export const TASK_TYPE = 'Task Type';
export const DURATION = 'Duration';
export const TASK_TILE = 'Task Title';
export const TASK_DESCRIPTION = 'Task Description';
export const APPROVER = 'Approver';
export const WORK_FROM_HOME = 'Work From Home';
export const WORK_FROM_OFFICE = 'Office Hours';
export const EXTERNAL_HOURS = 'External Hours';
export const CLIENT_OFFICE_HOURS = 'Client Office Hours';
export const WORK_TRAVEL_HOURS = 'Work Travel Hours';

export const WFH = 'WFH';
export const WFO = 'OFFICEHRS';
export const EXTERNAL = 'EXTERNAL';
export const CLIENT_OFFICE = 'CLIENT_OFFICE';
export const WORK_TRAVEL = 'WORK_TRAVEL';

export const APPRIASAL_STATUS = 'Is Appraisable';
export const DATE = 'Date';
export const ADD_TASK = 'Add Task';
export const NO_TASK = 'No Tasks...';
export const NO_WFH = 'No Wfh..';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const YYYY_MM_DD = 'YYYY-MM-DD';

export const TASK_EDIT = 'TASK_EDIT';
export const TASK_EDIT_CLOSE = 'TASK_EDIT_CLOSE';
export const TASK_DELETE = 'TASK_DELETE';
export const TASK_DELETE_CLOSE = 'TASK_DELETE_CLOSE';
export const TASK_ROW = 'TASK_ROW';
export const TASK_UPDATE_SUCCESS = 'Successfully updated the task';
export const TASK_UPDATE_FAILURE = 'Sorry Could not update task';

export const TaskFieldError = {
  INVALID_DURATION: '*Please enter a valid time duration',
  NUMBER_GREATER_THAN: 'Number of hours can not be greater than ',
  NUMBER_IS_ZERO: 'Duration must be greater than zero ',
  REQUIRED: '*Required',
  TITLE_MIN_NON_WHITESPACE:
    'Title requires at least 30 non-whitespace characters',
  DESCRIPTION_MIN_NON_WHITESPACE:
    'Description requires at least 100 non-whitespace characters',
};

/** Count characters that are not whitespace (spaces, tabs, newlines, etc.). */
export const countNonWhitespaceCharacters = (text) => {
  if (typeof text !== 'string') {
    return 0;
  }
  return text.replace(/\s/g, '').length;
};

export const wfhStatus = (status) => {
  switch (status) {
    case 'APPROVED':
      return 'Approved';
    case 'PENDING':
      return 'Pending';
    case 'REJECTED':
      return 'Rejected';
    case 'CANCELLED':
      return 'Cancelled';
    default:
      return status;
  }
};

export const wfhType = (wfhType) => {
  switch (wfhType) {
    case 'CASUAL_LEAVE':
      return 'Casual Leave';
    case 'WFH':
      return 'Work from home';
    case 'SICK_LEAVE':
      return 'Sick Leave';
    case 'MISCELLANEOUS_LEAVE':
      return 'Misc. Leave';
    default:
      return wfhType;
  }
};
